import { c as _c } from "react/compiler-runtime";
import { AnimatedChevronIcon, Select } from '@onefootprint/ui';
import type React from 'react';
export type Option<T> = {
  id: string;
  name: string;
  customData?: T;
};
export type DropdownSelectorProps<T> = {
  onValueChange: (value: string) => void;
  triggerAriaLabel: string;
  value: Option<T>;
  options?: Option<T>[];
  renderCustomData?: (option: Option<T>) => React.ReactNode;
};
const DropdownSelector = t0 => {
  const $ = _c(10);
  const {
    onValueChange,
    triggerAriaLabel,
    value,
    options
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options?.map(_temp) ?? [];
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value.name) {
    t2 = t3 => {
      const {
        isOpen
      } = t3;
      return <div className="flex items-center gap-1 text-body-2 max-md:min-h-10">{value.name}<AnimatedChevronIcon isOpen={isOpen} /></div>;
    };
    $[2] = value.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onValueChange || $[5] !== t1 || $[6] !== t2 || $[7] !== triggerAriaLabel || $[8] !== value.id) {
    t3 = <Select value={value.id} onChange={onValueChange} options={t1} aria-label={triggerAriaLabel} customTrigger={t2} />;
    $[4] = onValueChange;
    $[5] = t1;
    $[6] = t2;
    $[7] = triggerAriaLabel;
    $[8] = value.id;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default DropdownSelector;
function _temp(option) {
  return {
    value: option.id,
    label: option.name
  };
}